import React from "react";
import "./banner.scss";
import images from "./banner.js";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const banner = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="banner">
      <div className="header-dekstop">
        <div className="header-mobile">
          <Slider {...settings}>
            {images.map((image, index) => (
              <div>
                <img
                  className="image-banner"
                  key={index}
                  src={image}
                  alt="foto Banner"
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default banner;
